import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useConfig } from '@xingternal/hops';
import { IconEmail } from '@xingternal/icons';
import { ttt } from '@xingternal/malt-tracking';

import JobsSearch from '../../JobsSearch/JobsSearch';
import IconGoogle from '../IconGoogle';
import { PROP_CHANNEL } from '../../../../Components/PageviewTracker/PageviewTracker';

import {
  Button,
  ButtonsSection,
  Container,
  Content,
  Hero,
  Picture,
  InnerContainer,
  PictureContainer,
  MobilePictureContainer,
  StyledHeadline,
} from './HeaderSectionJobsSearchNoShapes.style';

import headerShapeIllustrationJpg from '../images/header_shape.png';
import headerShapeIllustrationWebp from '../images/header_shape.webp';

const HEADER_ILLUSTRATION_NO_LINE = {
  bitmapSrc: headerShapeIllustrationJpg,
  webpSrc: headerShapeIllustrationWebp,
};

const HeaderSectionJobsSearchNoShapes = () => {
  const { externalUrl } = useConfig();

  const EmailButton = (
    <Button
      variant="secondary"
      size="medium"
      icon={IconEmail}
      href={`${externalUrl}/start/signup?sc_o=losp_sign_up_button_click&sc_o_PropActionOrigin=losp_sign_up_button_click_cta_1`}
    >
      <FormattedMessage
        id="WELCOME_STARTPAGE_JOBS_VERSION_HEADER_BUTTON"
        defaultMessage="Register for free"
      />
    </Button>
  );

  const GoogleButton = (
    <Button
      variant="tertiary"
      size="medium"
      icon={IconGoogle}
      href={`${externalUrl}/signup/oauth`}
      onClick={() => {
        ttt.pageview(
          PROP_CHANNEL,
          'wbm/Welcome/start/index/google',
          {},
          {
            PropTrackAction: 'lp_google_click',
          }
        );
      }}
    >
      <FormattedMessage
        id="WELCOME_STARTPAGE_PROCEED_WITH_GOOGLE_BUTTON"
        defaultMessage="Continue with Google"
      />
    </Button>
  );

  const PictureComponent = (
    <FormattedMessage id="WELCOME_STARTPAGE_HEADER_IMAGE_ALT">
      {text => (
        <Picture alt={text} loading="lazy" {...HEADER_ILLUSTRATION_NO_LINE} />
      )}
    </FormattedMessage>
  );

  const JobsVersionSubttileMessage = (
    <FormattedMessage
      id="WELCOME_STARTPAGE_JOBS_VERSION_HEADER_SUBTITLE"
      defaultMessage="Or register now and we'll do the searching for you:"
    />
  );

  return (
    <Container>
      <InnerContainer>
        <Content>
          <Hero size="medium" sizeConfined="large" sizeWide="large">
            <FormattedMessage
              id={`WELCOME_STARTPAGE_JOBS_VERSION_HEADER_TITLE`}
              defaultMessage="Find the right job{br}\nfor you:"
              values={{
                br: <br />,
              }}
            />
          </Hero>
          <MobilePictureContainer>{PictureComponent}</MobilePictureContainer>
          <JobsSearch />
          <StyledHeadline size="xxlarge">
            {JobsVersionSubttileMessage}
          </StyledHeadline>
          <ButtonsSection>
            {EmailButton}
            {GoogleButton}
          </ButtonsSection>
        </Content>
        <PictureContainer>{PictureComponent}</PictureContainer>
      </InnerContainer>
    </Container>
  );
};

export default HeaderSectionJobsSearchNoShapes;
